import { PolicyFileIngestion } from '@/api/northlight/policy-file-ingestion';
import { Button } from '@/components/ui/button';
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '@/components/ui/tooltip';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { ArrowUpDown, Eye } from 'lucide-react';
import { Link } from 'react-router';

import { DownloadPolicies } from './download-policies';

export const columns: ColumnDef<PolicyFileIngestion>[] = [
	{
		accessorKey: 'id',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				File Id
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => <div className="font-medium">{row.original.id}</div>,
	},
	{
		accessorKey: 'fileName',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				File Name
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => <div className="font-medium">{row.original.fileName}</div>,
	},
	{
		accessorKey: 'importDate',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Import Date
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => {
			return (
				<div className="font-medium">
					{row.original.importDate ? format(row.original.importDate, 'P') : '---'}
				</div>
			);
		},
	},
	{
		accessorKey: 'totalTax',
		header: () => <div className="text-right">Total Tax</div>,
		cell: ({ row }) => {
			let formattedAmount;
			if (row.original.totalTax) {
				formattedAmount = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD',
				}).format(row.original.totalTax);
			}
			return <div className="text-right font-medium">{formattedAmount}</div>;
		},
	},
	{
		accessorKey: 'totalPremium',
		header: () => <div className="text-right">Total Premium</div>,
		cell: ({ row }) => {
			let formattedAmount;
			if (row.original.totalPremium) {
				formattedAmount = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD',
				}).format(row.original.totalPremium);
			}
			return <div className="text-right font-medium">{formattedAmount}</div>;
		},
	},
	{
		id: 'actions',
		cell: ({ row }) => (
			<div>
				<TooltipProvider>
					<Tooltip>
						<TooltipTrigger asChild>
							<Link to={`/northlight/policies/${row.original.id}`}>
								<Button className="m-auto" variant="ghost">
									<Eye size={16} />
								</Button>
							</Link>
						</TooltipTrigger>
						<TooltipContent>
							<p>View Policies</p>
						</TooltipContent>
					</Tooltip>
				</TooltipProvider>

				<DownloadPolicies fileIngestionId={row.original.id} />
			</div>
		),
	},
];
